import { render, staticRenderFns } from "./FavItem.vue?vue&type=template&id=d3cc5948"
import script from "./FavItem.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./FavItem.vue?vue&type=script&charset=utf-8&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports